export const passwordFields = [
  {
    id: 'currentPassword',
    label: 'Current password',
  },
  {
    id: 'newPassword',
    label: 'New password',
  },
  {
    id: 'confirmPassword',
    label: 'Confirm new password',
  },
];
